/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const onClientEntry = async () => {
  // Ensure datalayer is initialized
  window.dataLayer = window.dataLayer || [];

  // Intersection Observer Polyfill
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
  }

  // Suppress 404 errors for /shop/* routes (handled by store-front app)
  if (typeof window !== 'undefined' && window.___loader) {
    const originalFetch = window.___loader.loadPageDataJson;
    if (originalFetch) {
      window.___loader.loadPageDataJson = function (loadObj) {
        const { pagePath } = loadObj;
        if (pagePath && pagePath.startsWith('/shop/')) {
          // Return a resolved promise for shop routes to prevent 404 errors
          return Promise.resolve({
            ...loadObj,
            status: 'error',
            payload: null,
          });
        }
        return originalFetch.call(this, loadObj);
      };
    }
  }
};

export const disableCorePrefetching = () => {
  return window.location.host === 'curology.co';
};
